import { Grid } from '@mui/material';
import Card1 from './components/Card1';
import Card2 from './components/Card2';
import Card3 from './components/Card3';
import Card4 from './components/Card4';
import Card5 from './components/Card5';
import Card6 from './components/Card6';
import Navbar from './components/NavBar';

const sxGrid = {
  width: "100%",
  backgroundSize: 'cover',
  backgroundPosition: "bottom",
  height: '100vh',
  position: 'relative',
  zIndex: 0,
};

function AppDesktop(props) {
  return (
    <>      
      <Grid container sx={{ width: '100vw', position: 'relative' }}>
        <Navbar />
        <Grid id="title" item xs={12} sx={{ backgroundImage: "url(/assets/Card_1.png)", ...sxGrid }}>
          <Card1/>
        </Grid>
        <Grid id="presentazione" item xs={12} sx={{ backgroundImage: "url(/assets/Card_2.png)", ...sxGrid }}>
          <Card2/>
        </Grid>
        <Grid id="cosa-faremo" item xs={12} sx={{ ...sxGrid, height: '120vh' }}>
          <Card3/>
        </Grid>
        <Grid id="quando-rivolgersi" item xs={12} sx={{ backgroundImage: "url(/assets/Card_4.svg)", ...sxGrid }}>
          <Card4/>
        </Grid>
        <Grid id="contatti" item xs={12} sx={{ ...sxGrid, height: null }}>
          <Card5/>
        </Grid>
        <Grid item xs={12} sx={{ ...sxGrid, height: "220px", backgroundColor: '#527180' }}>
          <Card6/>
        </Grid>
      </Grid>
    </>
  );
}

export default AppDesktop;